import { jsx as r } from "react/jsx-runtime";
import t from "./index.es746.js";
import e from "classnames";
import { ColorIndicator as m } from "./index.es32.js";
const C = ({
  testId: o = "color-indicator-cell",
  entityColor: l,
  colorIndicator: a,
  gridDensity: c
}) => {
  const i = e(t.colorIndicatorCellRoot, t[c]);
  return /* @__PURE__ */ r("div", { className: i, "data-testid": o + "-container", children: /* @__PURE__ */ r(
    m,
    {
      entityColor: l,
      ...a,
      testId: o
    }
  ) });
};
export {
  C as ColorIndicatorCell
};
//# sourceMappingURL=index.es570.js.map
